export const SET_BOOKMARK_GROUPS = 'quiz-bookmark/SET_BOOKMARK_GROUPS';
export const SET_BOOKMARK_PAGE = 'quiz-bookmark/SET_BOOKMARK_PAGE';
export const SET_BOOKMARK_GROUP = 'quiz-bookmark/SET_BOOKMARK_GROUP';
